import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
import Slider from "react-slick";

import ObjPushCardFormation from './ObjPushCardFormation'
import IconSVG from "../../utilities/FrontFunctions/IconSVG"

import { equalHeight } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"

import '../../assets/css/0020_objects/0710_obj_carousel_formation.css'
import '../../assets/css/0020_objects/0900_obj_parcours_perso_comptoir_dermato.css'

class ObjParcoursPersoHomeComptoirDermato extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
		this.handleButtonFav = this.props.handleButtonFav.bind(this)
	}

	componentDidMount() {
		this.applyEqualHeight();
	}
	applyEqualHeight() {
		setTimeout(() => {
			equalHeight(".obj_parcours_perso_comptoir_dermato .obj_push_card .ctn_text_card");
		});
	}

    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

	render() {
        const { datasParcour } = this.props;

		const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: false,
			infinite: false,
			slidesToShow: 2,
            swipeToSlide: true,
            onSwipe: this.onSwipe.bind(this),
            dots: false,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: true,
            speed: 750,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: "10%",
                        centerMode: true,
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
        }

		return (<>{datasParcour && <>
			<div className="obj_parcours_perso_comptoir_dermato">
				<div className="ctn_title">
					<h2 className="t_title">
						<IconSVG icon="magic_wand" />
						<strong>{datasParcour.Parcours_Title}</strong>
					</h2>
				</div>

				<div className="ctn_carrousel">

					<Slider {...settings} ref={sliderRef}>
                        {datasParcour.Formations.map((datasTraining, index) => (
                            <div className="item" key={index} >
                                <ObjPushCardFormation typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                            </div>
                        ))}
					</Slider>

				</div>
			</div>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(ObjParcoursPersoHomeComptoirDermato));